export default "__VITE_ASSET__d1bf4dce__"